import { FILTER_FINANCIAL_PRESS_RELEASE_KEY } from './financial-press-release';
import { FILTER_HOME_KEY, searchHome } from './home';
import { FILTER_HUB_ACTUS_KEY, searchHubActualites } from './hub-actualites';
import {
  FILTER_HUB_FINANCIAL_PRESS_RELEASE_KEY,
  searchFinancialPressRelease,
} from './hub-financial-press-release';
import {
  FILTER_HUB_FINANCIAL_PUBLICATION_KEY,
  searchFinancialPublications,
} from './hub-financial-publication';
import { FILTER_HUB_NEWSROOM_KEY, searchHubNewsroom } from './hub-newsroom';
import {
  FILTER_INVESTORS_PRESS_RELEASE_KEY,
  searchInvestorsPressRelease,
} from './investors-press-release';
import {
  FILTER_INVESTOR_PRESS_RELEASE_DASHBOARD_KEY,
  searchInvestorsPressReleaseDashboard,
} from './investors-press-release-dashboard';
import {
  FILTER_INVESTORS_RSE_DOCUMENTS,
  searchInvestorsRSEDocumnents,
} from './investors-rse-documents';
import { FILTER_NEWSROOM_KEY, searchNewsroom } from './newsroom';
import {
  FILTER_REGULATED_INFORMATION_KEY,
  searchRegulatedInformations,
} from './regulated-information';
import { FILTER_GLOBAL_SEARCH_KEY, searchGlobal } from './search-page';

export const mappedSearch: Record<string, any> = {
  [FILTER_GLOBAL_SEARCH_KEY]: searchGlobal,
  [FILTER_HOME_KEY]: searchHome,
  [FILTER_HUB_ACTUS_KEY]: searchHubActualites,
  [FILTER_HUB_FINANCIAL_PRESS_RELEASE_KEY]: searchFinancialPressRelease,
  [FILTER_HUB_FINANCIAL_PUBLICATION_KEY]: searchFinancialPublications,
  [FILTER_HUB_NEWSROOM_KEY]: searchHubNewsroom,
  [FILTER_NEWSROOM_KEY]: searchNewsroom,
  [FILTER_FINANCIAL_PRESS_RELEASE_KEY]: searchFinancialPressRelease,
  [FILTER_INVESTOR_PRESS_RELEASE_DASHBOARD_KEY]:
    searchInvestorsPressReleaseDashboard,
  [FILTER_INVESTORS_PRESS_RELEASE_KEY]: searchInvestorsPressRelease,
  [FILTER_REGULATED_INFORMATION_KEY]: searchRegulatedInformations,
  [FILTER_INVESTORS_RSE_DOCUMENTS]: searchInvestorsRSEDocumnents,
};
